function expandProductDescription(event) {
  event.preventDefault();
  
  const detailsEl = document.querySelector('.js-product-description-long').closest('details');
  if (!detailsEl) return;
  
  const summaryEl = detailsEl.querySelector('summary');
  if (!summaryEl) return;
  
  // Expand the accordion
  detailsEl.open = true;
  
  // Wait for expansion to complete, then scroll summary into center view
  setTimeout(() => {
    const rect = summaryEl.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    const offset = rect.top + scrollY - (window.innerHeight / 2) + (rect.height / 2) + 200;
    
    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    });
  }, 100);
}
